import {connect} from 'react-redux'
import React, {Component, Fragment} from 'react'
import {Row} from 'reactstrap'
import CategorySearch from 'catalog/components/CategorySearch'
import CategoryList from 'catalog/containers/CategoryList'
import NewCategory from 'catalog/components/NewCategory'
import PropTypes from 'prop-types'
import CategoryBreadcrumbs from 'catalog/containers/CategoryBreadcrumbs';
import SubCategoryList from 'catalog/containers/SubCategoryList';
import CategoryDetail from 'catalog/containers/CategoryDetail';

@connect(
    state => ({
        activeCategory: state.categories.activeCategory,
        activeSubcategory: state.categories.activeSubcategory,
    })
)
export default class Catalog extends Component {

    render() {
        const {
            activeCategory,
            activeSubcategory
        } = this.props;
        let display;
        if(!activeCategory) {
            display = <CategoryList/>
        }
        if(activeCategory && !activeSubcategory) {
            display = <SubCategoryList />
        }
        if(activeCategory && activeSubcategory) {
            display = <CategoryDetail />
        }
        return (
            <Fragment>
                <Row form style={{'marginBottom': '1em', 'marginTop': '1em'}}>
                    <CategorySearch/>
                    <NewCategory/>
                </Row>
                <CategoryBreadcrumbs />
                {display}
            </Fragment>
        )
    }
}

Catalog.propTypes = {
    activeCategory: PropTypes.object,
    activeSubcategory: PropTypes.object
}
